import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../api/useApi";
import { GetUserRequest, type GetUserResponse, type IReturn } from "src/api/Tmd.dtos";

const getData = (response?: SWRResponse<GetUserResponse, GetUserResponse>) =>
    response?.data?.userDetails;
const getError = (response?: SWRResponse<GetUserResponse, GetUserResponse>) =>
    (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetUserResponse, GetUserResponse>) => ({});

const useAuthenticatedUser = (
    configuration?: SWRConfiguration<GetUserResponse, GetUserResponse>,
) => {
    const getRequest = useMemo(() => {
        return (): IReturn<GetUserResponse> => {
            return new GetUserRequest();
        };
    }, []);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useAuthenticatedUser;
